import type { Brand } from "@/core/brand/brand-context";
import type { BadgeTone } from "@/ui/badge";

/** A brand's status for its own team: what it means for their customers. */
export const BRAND_STATUS_DISPLAY: Record<Brand["status"], { label: string; tone: BadgeTone }> = {
  DRAFT: { label: "Not live yet", tone: "warn" },
  ACTIVE: { label: "Live", tone: "success" },
  SUSPENDED: { label: "Paused by Brocoly", tone: "danger" },
  CLOSED: { label: "Closed", tone: "neutral" },
};
